import React, { Component, Fragment, ReactNode } from 'react'

import { displayPhone } from '../../../helpers/displayFormatHelper'
import { UserBannerInfoCard } from './userBannerInfoCard'
import { CheckMark } from '../../../icons/checkMark'
import { User, Address } from '../../../core/types'
import { CancelX } from '../../../icons/cancelX'
import QuoteHomeProtectionBtn from '../QuoteHomeProtectionBtn'

export interface Props {
  user: User
  address: Address | undefined
}

export class UserBannerProfilePanel extends Component<Props> {
  static displayName = 'UserBannerProfilePanel'

  render() {
    const { address, user } = this.props
    const { email, phone, birthday, currentAddress, emailVerified, attribution } = user
    let addressSection: ReactNode = null
    const renderAddress = (address) => {
      const { line1, line2, city, state, zip } = address
      return (
        <Fragment>
          {`${line1},`}
          {line2 && ` ${line2},`}
          <br />
          {`${city}, ${state} ${zip}`}
        </Fragment>
      )
    }

    if (address) {
      addressSection = renderAddress(address)
    } else if (currentAddress) {
      addressSection = renderAddress(currentAddress)
    }

    const emailWithCheck = email ? (
      <div className="user-banner__email">
        {emailVerified ? (
          <div className="user-banner__email-image">
            <CheckMark color="#01c0a0" height="16px" width="16px" />
          </div>
        ) : <div className="user-banner__email-image">
              <CancelX color="#ff0000" height="16px" width="16px" />
            </div>}
        <p className="user-banner__email-text">{email}</p>
      </div>
    ) : null

    const addressContent = (
      <div className="user-banner__address-card-content">
        {addressSection}
        <QuoteHomeProtectionBtn user={user} address={address} />
      </div>
    )

    return (
      <div
        data-test="user-banner-profile-panel"
        className="user-banner__profile-panel"
      >
        <UserBannerInfoCard title="Email address" content={emailWithCheck} />
        <UserBannerInfoCard title="DOB" content={birthday} />
        <UserBannerInfoCard
          title="Phone number"
          content={phone && displayPhone(phone)}
          attribution={attribution}
        />
        <UserBannerInfoCard title="Current address" content={addressContent} />
      </div>
    )
  }
}
